import { z } from 'zod';
/** Internal BFF-owned setup context; never included in public session responses. */
export const VoiceStartupFallbackSchema = z
    .object({
    tokenHash: z.string().regex(/^[a-f0-9]{64}$/),
    contentKey: z.string().min(1).max(200),
    moderatorId: z.string(),
    request: z.record(z.string(), z.unknown()),
    talkingSpeed: z.number().nullable().optional(),
    previewId: z.string().optional(),
    assignmentToken: z.string().optional(),
})
    .strict();
export const VoiceStartupFallbackAccessSchema = z
    .object({ tokenHash: z.string().regex(/^[a-f0-9]{64}$/) })
    .strict();
//# sourceMappingURL=VoiceStartupFallback.js.map